import React, { Component } from 'react';
import { Button, Col, Drawer, Form, Input, Popover, Row, Table } from 'antd';
import { Link } from 'react-router';
import moment from 'moment';
import '../expenses.less';
import { queryPaymentOrgRecord } from '@api/finance/payment';

const FormItem = Form.Item;

class Manage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: {
        list: [],
        pagination: {},
      },
      condition: '',
    };
  }

  componentDidMount() {
    this.loadData();
  }

  getPaymentOrgRecord = params => {
    queryPaymentOrgRecord(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          dataSource: {
            list: res.data,
            pagination: {
              total: res.totalSize,
              pageSize: 15,
            },
          },
        });
      }
    });
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.pagination = {
      limit: pagination.pageSize,
      start: pagination.current,
    };
    this.current = pagination.current;
    this.loadData();
  };

  loadData = () => {
    const { condition } = this.state;
    const params = {
      companyUuid: this.props.org.companyUuid,
      condition,
      ...this.pagination,
    };
    this.getPaymentOrgRecord(params);
  };

  onChange = () => {};

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState(
          {
            condition: values.condition,
          },
          () => {
            this.loadData();
          },
        );
      }
    });
  };

  renderSearchForm = () => {
    const {
      form: { getFieldDecorator },
    } = this.props;
    const { condition } = this.state;
    return (
      <div>
        <Form layout="inline" onSubmit={this.handleSubmit} style={{ textAlign: 'right' }}>
          <FormItem>
            {getFieldDecorator('condition', {
              initialValue: condition || null,
            })(<Input placeholder="请输入关键字" />)}
          </FormItem>
          <FormItem>
            <Button htmlType="submit">查询</Button>
          </FormItem>
        </Form>
      </div>
    );
  };

  columns = () => {
    return [
      {
        title: '付款单号',
        dataIndex: 'no',
        key: 'no',
        render: (text, record) => {
          return <Link to={`/finance/p_manage/open/${record.uuid}`}>{text || '查看'}</Link>;
        },
      },
      {
        title: '申请人',
        dataIndex: 'createUserName',
        key: 'createUserName',
      },
      {
        title: '金额',
        dataIndex: 'price',
        key: 'price',
      },
      {
        title: '申请理由',
        dataIndex: 'reason',
        key: 'reason',
        width: 200,
        render: text => {
          const content = (
            <div style={{ maxWidth: '600px' }}>
              <span>{text}</span>
            </div>
          );
          return (
            <Popover content={content}>
              <p className="ellip">{text}</p>
            </Popover>
          );
        },
      },
      {
        title: '申请时间',
        dataIndex: 'createTime',
        key: 'createTime',
        render: (text, record) => {
          return <span>{moment.unix(text / 1000).format('YYYY-MM-DD')}</span>;
        },
      },
      {
        title: '完成时间',
        dataIndex: 'finishTime',
        key: 'finishTime',
        render: (text, record) => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '状态',
        dataIndex: 'long',
        render: (text, record) => {
          return record.status ? (
            <span>
              已完成
              <span>(用时{record.consume}天)</span>
            </span>
          ) : (
            <span>审核中</span>
          );
        },
      },
    ];
  };

  render() {
    const {
      dataSource: { list, pagination },
    } = this.state;
    const { org } = this.props;
    return (
      <Drawer
        visible
        width="70%"
        title={org.company}
        onClose={() => this.props.handleVisible(false)}
      >
        <div>
          <Row style={{ paddingBottom: '20px' }}>
            <Col span={13} />
            <Col span={11}>
              <div className="tableListForm">{this.renderSearchForm()}</div>
            </Col>
          </Row>
          <Table
            columns={this.columns()}
            dataSource={list}
            pagination={pagination}
            rowKey="uuid"
            size="small"
            onChange={this.handleTableChange}
          />
        </div>
      </Drawer>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(Manage);



// WEBPACK FOOTER //
// ./src/components/finance/payment/TableRecordByOrg.js